import { LabActionDto, MyleActionDTO, MyleNoteDTO, ObservationDTO } from "@/Common/Api/Labs/Dto/Responses/LabMessageGroupDTO";
import { MyleHelper } from "@/Common/Helpers/MyleHelper";
import { Note as MyleModelsCommonNote } from "@/Common/Models/Note";
import { LabActionInboxes, LabInboxes, LabTabViews, RedirectTo } from "@/Common/Models/UI/Enums";
import { CheckboxUIModel } from "@/Common/Models/UI/Inputs/CheckboxUIModel";
import * as LocalOperations from "@/Common/Operations/operations.local";
import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";
import { BaseOperationHandler } from "@/Common/Stores/Handlers/Local/BaseOperationHandler";
import { LabsStore } from "@/Labs/Stores/LabsStore";

class LabsTabHandler extends BaseOperationHandler {
    private labnoteDebounce: number;

    public constructor() {
        super();

        this.RegisterOperation(LocalOperations.Labs.SwitchTo_AllLabsInbox, this.SwitchTo_AllLabsInbox);
        this.RegisterOperation(LocalOperations.Labs.SwitchTo_NewLabsInbox, this.SwitchTo_NewLabsInbox);
        this.RegisterOperation(LocalOperations.Labs.SwitchTo_SuspendedLabsInbox, this.SwitchTo_SuspendedLabsInbox);
        this.RegisterOperation(LocalOperations.Labs.SwitchTo_ClassifiedLabsInbox, this.SwitchTo_ClassifiedLabsInbox);

        this.RegisterOperation(LocalOperations.Labs.SwitchTo_LabActionTous, this.SwitchTo_LabActionTous);
        this.RegisterOperation(LocalOperations.Labs.SwitchTo_LabActionNurses, this.SwitchTo_LabActionNurses);
        this.RegisterOperation(LocalOperations.Labs.SwitchTo_LabActionSecretaries, this.SwitchTo_LabActionSecretaries);
        this.RegisterOperation(LocalOperations.Labs.SwitchTo_LabActionCompleted, this.SwitchTo_LabActionCompleted);

        this.RegisterOperation(LocalOperations.Misc.RedirectToTab, this.OpenLab);

        // Notes And Actions popups controls
        this.RegisterOperation(LocalOperations.LabsUI.ActionNotesClick, this.ActionNoteClick);
        this.RegisterOperation(LocalOperations.LabsUI.ActionCheckBoxClick, this.ActionCheckboxClick);
        this.RegisterOperation(LocalOperations.LabsUI.ActionNote_Text_Changed, this.OnActionNoteTextChanged);
        this.RegisterOperation(LocalOperations.LabsUI.ActionNote_Save, this.ActionNote_Save);
        this.RegisterOperation(LocalOperations.LabsUI.NotesClick, this.NotesClick);
        this.RegisterOperation(LocalOperations.LabsUI.Note_Save, this.Note_Save);
        this.RegisterOperation(LocalOperations.LabsUI.Note_Text_Changed, this.OnNoteTextChanged);
        this.RegisterOperation(LocalOperations.LabsUI.ActionDetails_Click, this.ActionDetails_Click);
        this.RegisterOperation(LocalOperations.LabsUI.ActionDetails_CompleteAction, this.ActionDetailComplete);
        this.RegisterOperation(LocalOperations.LabsUI.ActionDetails_DeleteAction, this.ActionDetailDelete);

        this.RegisterOperation(LocalOperations.LabsUI.ClosePopups, this.ClosePopups);

        this.RegisterOperation(LocalOperations.LabsUI.ResultDetailClick, this.ResultDetailClick);
        this.RegisterOperation(LocalOperations.LabsUI.OpenManualEntryFormPopup, this.OpenManualEntryFormPopUp);
        this.RegisterOperation(LocalOperations.LabsUI.CloseManualEntryFormPopup, this.CloseManualEntryFormPopUp);

        this.RegisterOperation(LocalOperations.Labs.SwitchTo_LabManualResults, this.SwitchTo_LabManualResults);

        this.labnoteDebounce = -1;
    }

    private OpenLab(request: LocalEvent, store: LabsStore): void {
        var target = request.Get<RedirectTo>("target");
        if (target === RedirectTo.Labs) {
            store.ShowLabTab();
            var LabFillerIDSelected = request.Get<string>("value");
            store.LabActions.GetLab(LabFillerIDSelected);
        }
    }

    private SwitchTo_AllLabsInbox(request: LocalEvent, store: LabsStore): void {
        store.LabsInboxModel = store.LabsInboxModel.set("CurrentPage", 1);
        store.LabsInboxModel = store.LabsInboxModel.set("CurrentInbox", LabInboxes.All);
        store.Model = store.Model.set("CurrentView", LabTabViews.Inbox);
        store.LabActions.RefreshLabs();
    }

    private SwitchTo_NewLabsInbox(request: LocalEvent, store: LabsStore): void {
        store.LabsInboxModel = store.LabsInboxModel.set("CurrentPage", 1);
        store.LabsInboxModel = store.LabsInboxModel.set("CurrentInbox", LabInboxes.New);
        store.Model = store.Model.set("CurrentView", LabTabViews.Inbox);
        store.LabActions.RefreshLabs();
    }

    private SwitchTo_SuspendedLabsInbox(request: LocalEvent, store: LabsStore): void {
        store.LabsInboxModel = store.LabsInboxModel.set("CurrentPage", 1);
        store.LabsInboxModel = store.LabsInboxModel.set("CurrentInbox", LabInboxes.Suspended);
        store.Model = store.Model.set("CurrentView", LabTabViews.Inbox);
        store.LabActions.RefreshLabs();
    }

    private SwitchTo_ClassifiedLabsInbox(request: LocalEvent, store: LabsStore): void {
        store.LabsInboxModel = store.LabsInboxModel.set("CurrentPage", 1);
        store.LabsInboxModel = store.LabsInboxModel.set("CurrentInbox", LabInboxes.Classified);
        store.Model = store.Model.set("CurrentView", LabTabViews.Inbox);
        store.LabActions.RefreshLabs();
    }

    private SwitchTo_LabActionTous(request: LocalEvent, store: LabsStore): void {
        store.LabsActionInboxModel = store.LabsActionInboxModel.set("CurrentPage", 1);
        store.LabsActionInboxModel = store.LabsActionInboxModel.set("CurrentInbox", LabActionInboxes.All);
        // store.LabsActionInboxModel = store.LabsActionInboxModel.set("GlobalActionSearchText", "");

        store.Model = store.Model.set("CurrentView", LabTabViews.ActionsInbox);
        store.LabActions.RefreshActions(LabActionInboxes.All, store.LabsActionInboxModel.get("GlobalActionSearchText"), store.LabsActionInboxModel.get("SortColumn"), store.LabsActionInboxModel.get("SortColumnDirection"));
        store.LabActions.GetLabsActionsCount();
    }

    private SwitchTo_LabActionNurses(request: LocalEvent, store: LabsStore): void {
        store.LabsActionInboxModel = store.LabsActionInboxModel.set("CurrentPage", 1);
        store.LabsActionInboxModel = store.LabsActionInboxModel.set("CurrentInbox", LabActionInboxes.Nurses);
        // store.LabsActionInboxModel = store.LabsActionInboxModel.set("GlobalActionSearchText", "");

        store.Model = store.Model.set("CurrentView", LabTabViews.ActionsInbox);
        store.LabActions.RefreshActions(LabActionInboxes.Nurses, store.LabsActionInboxModel.get("GlobalActionSearchText"), store.LabsActionInboxModel.get("SortColumn"), store.LabsActionInboxModel.get("SortColumnDirection"));
        store.LabActions.GetLabsActionsCount();
    }

    private SwitchTo_LabActionSecretaries(request: LocalEvent, store: LabsStore): void {
        store.LabsActionInboxModel = store.LabsActionInboxModel.set("CurrentPage", 1);
        store.LabsActionInboxModel = store.LabsActionInboxModel.set("CurrentInbox", LabActionInboxes.Secretaries);
        // store.LabsActionInboxModel = store.LabsActionInboxModel.set("GlobalActionSearchText", "");

        store.Model = store.Model.set("CurrentView", LabTabViews.ActionsInbox);
        store.LabActions.RefreshActions(LabActionInboxes.Secretaries, store.LabsActionInboxModel.get("GlobalActionSearchText"), store.LabsActionInboxModel.get("SortColumn"), store.LabsActionInboxModel.get("SortColumnDirection"));
        store.LabActions.GetLabsActionsCount();
    }

    private SwitchTo_LabActionCompleted(request: LocalEvent, store: LabsStore): void {
        store.LabsActionInboxModel = store.LabsActionInboxModel.set("CurrentPage", 1);
        store.LabsActionInboxModel = store.LabsActionInboxModel.set("CurrentInbox", LabActionInboxes.Completed);
        // store.LabsActionInboxModel = store.LabsActionInboxModel.set("GlobalActionSearchText", "");

        store.Model = store.Model.set("CurrentView", LabTabViews.ActionsInbox);
        store.LabActions.RefreshActions(LabActionInboxes.Completed, store.LabsActionInboxModel.get("GlobalActionSearchText"), store.LabsActionInboxModel.get("SortColumn"), store.LabsActionInboxModel.get("SortColumnDirection"));
        store.LabActions.GetLabsActionsCount();
    }

    // Notes // Actions Control

    private ActionOrNoteClick(request: LocalEvent, store: LabsStore, type: number): void {
        let labFillerId = request.Get<string>("labFillerId");
        let obx = request.Get<ObservationDTO>("observation");
        let noteDTOs = request.Get<MyleNoteDTO[]>("notes");
        const detail: string = request.Get<string>("detail");

        var event = request.Get<React.MouseEvent>("event");
        $(event.target).closest("tr").addClass("active");

        let OriginalOBXValue = obx ? obx.ValueText : "";
        let OBXName = obx ? obx.Text : "";
        let OBXUnit = obx ? obx.UnitsIdentifier : "";
        let ObservationIdentifier = obx ? obx.Identifier : null;

        let isForGlobalNote = request.Get<boolean>("isGlobal");
        store.Model = store.Model.set("IsGlobalNote", isForGlobalNote);

        var controlId = "";
        if (type == 2) { // Action Detail
            controlId = "lab_actionsdetails_dropdown_main";

            store.Model = store.Model.set("Action_CurrentLabIDForActionDetails", labFillerId);
            store.Model = store.Model.set("Action_DetailsWindowOpen", true);
            store.Model = store.Model.set("Action_DetailsTopPosition", event.clientY);
            store.Model = store.Model.set("Action_DetailsLeftPosition", event.clientX - 600);

            // Details
            store.Model = store.Model.set("Action_DetailsModel", request.Get<MyleActionDTO>("actionItem"));
        }
        else if (type == 1) { // New Action popup
            controlId = "lab_actions_dropdown_main";

            store.Model = store.Model.set("Action_CurrentLabIDForNotes", labFillerId);
            store.Model = store.Model.set("Action_NoteWindowOpen", true);
            store.Model = store.Model.set("Action_NoteTopPosition", event.clientY);
            store.Model = store.Model.set("Action_NoteLeftPosition", event.clientX - 600);

            // Obx
            store.Model = store.Model.set("Action_CurrentElementIDForNotes", ObservationIdentifier);
            store.Model = store.Model.set("Action_OriginalOBXValue", OriginalOBXValue);
            store.Model = store.Model.set("Action_OBXName", OBXName);
            store.Model = store.Model.set("Action_OBXUnit", OBXUnit);
        }
        else if (type == 0) { // New Note Popup
            controlId = "lab_notes_dropdown_main";

            store.Model = store.Model.set("CurrentLabIDForNotes", labFillerId);
            store.Model = store.Model.set("NoteWindowOpen", true);
            store.Model = store.Model.set("NoteTopPosition", event.clientY);
            store.Model = store.Model.set("NoteLeftPosition", event.clientX - 600);

            // Obx
            store.Model = store.Model.set("CurrentElementIDForNotes", ObservationIdentifier);
            store.Model = store.Model.set("Note_OBXName", OBXName);
            store.Model = store.Model.set("Note_OBXUnit", OBXUnit);
            store.Model = store.Model.set("Note_OBXValue", OriginalOBXValue);

            let notes = noteDTOs.map(y => {
                var tmpNote = new MyleModelsCommonNote();
                tmpNote.ContactId = cacheStore.GetCliniciansPersonsByContactFacetId(y.EmployeeId).ContactId;
                tmpNote.NoteContent = y.Comment;
                tmpNote.NoteDate = y.TimeStamp;
                tmpNote.type = "2 - note";
                return tmpNote;
            });

            store.Model = store.Model.set("CurrentLabNotes", Immutable.List(notes));
        }
        else if (type === 3) { // New Note with Detail
            const isManualLabEntry = request.Get<boolean>("isManualLabEntry");

            store.Model = store.Model.set("CurrentLabIsManualResult", isManualLabEntry);
            store.Model = store.Model.set("CurrentLabIDForNotes", labFillerId);
            store.Model = store.Model.set("ResultDetailPopupOpen", true);

            // Obx
            store.Model = store.Model.set("CurrentElementIDForNotes", ObservationIdentifier);
            store.Model = store.Model.set("Note_OBXName", OBXName);
            store.Model = store.Model.set("Note_OBXUnit", OBXUnit);
            store.Model = store.Model.set("Note_OBXValue", OriginalOBXValue);

            let notes = noteDTOs.map(p => {
                const tmpNote = new MyleModelsCommonNote();
                tmpNote.ContactId = cacheStore.GetCliniciansPersonsByContactFacetId(p.EmployeeId).ContactId;
                tmpNote.NoteContent = p.Comment;
                tmpNote.NoteDate = p.TimeStamp;
                tmpNote.type = "2 - note";
                return tmpNote;
            });

            store.Model = store.Model.set("CurrentLabNotes", Immutable.List(notes));
            store.Model = store.Model.set("CurrentLabDetailsValue", detail);

            return;
        }

        // Set Focus and Make sure the popup is within windowRnage
        var a = 0;
        if ($("div[data-ctrlref]").length > 0) {
            a = $("div[data-ctrlref]").position().top;
        }
        else if ($(".patient-profile-footer").length > 0) {
            a = $(".patient-profile-footer").position().top;
        }
        a = a - (event.clientY);

        window.setTimeout(
            () => {
                $("#" + controlId).css("visibility", "hidden");
                $("#" + controlId).removeClass("displaced");
                var h = $("#" + controlId).height();
                $("#" + controlId).find("textarea").focus();
                if (h > a) {
                    var t = $("#" + controlId).position().top;
                    var tp = t - h;
                    if (tp < 52) tp = 52;
                    $("#" + controlId).css("top", tp + "px");
                    $("#" + controlId).addClass("displaced");
                }
                $("#" + controlId).css("visibility", "visible");
            },
            30
        );
    }

    private ForwardActionNoteToFollowUpAndPlan(cleanLabfillerID: string, textFollowUp: string, textLabArea: string): void {
        window.setTimeout(
            () => {
                var operation2 = new LocalEvent(LocalOperations.Misc.ClickableTextControlAppend);
                operation2.AddItem("value", cacheStore.GetString("ResultReviewText"));
                operation2.AddItem("SpecificTextControlId", "lab_note_reason" + cleanLabfillerID);
                operation2.AddItem("ApplyOnlyIfFieldIsNullOrEmpty", true);
                LocalEventDispatcher.dispatch(operation2);

                var operation = new LocalEvent(LocalOperations.Misc.ClickableTextControlAppend);
                operation.AddItem("value", textLabArea);
                operation.AddItem("SpecificTextControlId", "lab_note_Laboratoire" + cleanLabfillerID);
                operation.AddItem("ApplyOnlyIfFieldIsNullOrEmpty", false);
                LocalEventDispatcher.dispatch(operation);

                var operation = new LocalEvent(LocalOperations.Misc.ClickableTextControlAppend);
                operation.AddItem("value", textFollowUp);
                operation.AddItem("SpecificTextControlId", "lab_note_FollowUp" + cleanLabfillerID);
                operation.AddItem("ApplyOnlyIfFieldIsNullOrEmpty", false);
                LocalEventDispatcher.dispatch(operation);
            },
            50
        );
    }

    private ActionDetailComplete(request: LocalEvent): void {
        var actionId = request.Get<string>("SubReferenceId");
        labsStore.LabActions.CompleteAction(actionId, sessionStore.getCurrentEmployee().ContactFacetId);
    }

    private ActionDetailDelete(request: LocalEvent): void {
        var actionId = request.Get<string>("SubReferenceId");

        labsStore.LabActions.DeleteAction(actionId);
    }

    private ActionCheckboxClick(request: LocalEvent, store: LabsStore): void {
        var lookupId = request.Get<string>("id");

        store.ToggleActionCheckbox(store, lookupId);
    }

    private ActionNoteClick(request: LocalEvent, store: LabsStore): void {
        this.ActionOrNoteClick(request, store, 1);
    }

    private NotesClick(request: LocalEvent, store: LabsStore): void {
        this.ActionOrNoteClick(request, store, 0);
    }

    private ActionDetails_Click(request: LocalEvent, store: LabsStore): void {
        this.ActionOrNoteClick(request, store, 2);
    }

    private ResultDetailClick(request: LocalEvent, store: LabsStore): void {
        this.ActionOrNoteClick(request, store, 3);
    }

    private Note_Save(request: LocalEvent, store: LabsStore): void {
        let labFillerId = request.Get<string>("ReferenceId");
        let elementId = request.Get<string>("SubReferenceId");
        let noteText = request.Get<string>("value");
        const details: string = request.Get<string>("details");
        const isManualLabEntry = request.Get<boolean>("isManualLabEntry");

        store.LabActions.SaveLabActionNote(null, noteText, labFillerId, elementId, details, isManualLabEntry);

        if (store.Model.get("CurrentView") == LabTabViews.Lab) {
            let isGlobalNote = store.Model.get("IsGlobalNote");

            // get lab description
            let lab = store.LabModel.get("LabMessage");
            let labDesc = "";
            if (lab != null) {
                labDesc = lab.Model.Description;
            }

            // Forward to FollowUp TextBox
            let textFollowUp = isGlobalNote ? labDesc : store.Model.get("Note_OBXName") + " : ";
            if (noteText != null && noteText != "")
                textFollowUp += "\r\n" + "Note : " + noteText + "\r\n";

            let textLabArea = store.Model.get("Note_OBXName");
            if (store.Model.get("Note_OBXValue") != null && store.Model.get("Note_OBXValue").length > 0)
                textLabArea = textLabArea + " : " + store.Model.get("Note_OBXValue") + " " + store.Model.get("Note_OBXUnit");

            let cleanLabFillerId = cacheStore.Helper.RemoveDiacritics(MyleHelper.RemoveSpaces(labFillerId)).replaceAll("/", "");

            if (isGlobalNote)
                this.ForwardActionNoteToFollowUpAndPlan(cleanLabFillerId, "", textFollowUp); // when we have a global note, we save the note in LAB section, not in followup
            else
                this.ForwardActionNoteToFollowUpAndPlan(cleanLabFillerId, textFollowUp, textLabArea);
        }
    }

    private ActionNote_Save(request: LocalEvent, store: LabsStore): void {
        if (this.labnoteDebounce !== -1) {
            clearTimeout(this.labnoteDebounce);
            this.labnoteDebounce = -1;
        }

        this.labnoteDebounce = window.setTimeout(() => {
            var self = this;

            let LabFillerId = request.Get<string>("ReferenceId");
            let ElementId = request.Get<string>("SubReferenceId");
            let noteText = request.Get<string>("value");
            let OBXvalue = store.Model.get("Action_OriginalOBXValue");

            let textFollowUp = store.Model.get("Action_OBXName") + " : ";
            let labActionDTOs: LabActionDto[] = [];
            store.Model.get("Action_CheckboxesSecretaries").forEach(y => {
                if (y.Checked) {
                    textFollowUp += cacheStore.GetLookupById(y.Id).GetValue() + ", ";
                    labActionDTOs.push(self.ToLabActionDTO(y, OBXvalue));
                }
            });
            store.Model.get("Action_CheckboxesNurses").forEach(y => {
                if (y.Checked) {
                    textFollowUp += cacheStore.GetLookupById(y.Id).GetValue() + ", ";
                    labActionDTOs.push(self.ToLabActionDTO(y, OBXvalue));
                }
            });

            store.LabActions.SaveLabActionNote(labActionDTOs, noteText, LabFillerId, ElementId, null);

            if (store.Model.get("CurrentView") == LabTabViews.Lab) {
                if (noteText != null && noteText != "")
                    textFollowUp += "\r\n" + "Note : " + noteText + "\r\n";

                // Forward to FollowUp TextBox
                let textLabArea = store.Model.get("Action_OBXName");
                if (OBXvalue != null && OBXvalue.length > 0)
                    textLabArea = textLabArea + " : " + OBXvalue + " " + store.Model.get("Action_OBXUnit");

                let cleanLabFillerId = cacheStore.Helper.RemoveDiacritics(MyleHelper.RemoveSpaces(LabFillerId)).replaceAll("/", "");
                this.ForwardActionNoteToFollowUpAndPlan(cleanLabFillerId, textFollowUp, textLabArea);
            }
        }, 350);
    }

    private ToLabActionDTO(item: CheckboxUIModel, OBXvalue: string): LabActionDto {
        return {
            LookupId: item.Id,
            ActionType: item.Position,
            OriginalValue: OBXvalue
        };
    }

    private OnNoteTextChanged(request: LocalEvent, store: LabsStore): void {
        store.Model = store.Model.set("CurrentLabNoteValue", request.Get<string>("value"));
    }

    private OnActionNoteTextChanged(request: LocalEvent, store: LabsStore): void {
        store.Model = store.Model.set("Action_CurrentLabNoteValue", request.Get<string>("value"));
    }

    private ClosePopups(request: LocalEvent, store: LabsStore): void {
        window.setTimeout(() => $("table.myle-table tbody tr").removeClass("active"), 100);
        store.CloseActionNotePopup(store);
    }

    private OpenManualEntryFormPopUp(request: LocalEvent, store: LabsStore): void {
        store.Model = store.Model.set("IsManualResultsFormPopupOpen", true);
    }

    private CloseManualEntryFormPopUp(request: LocalEvent, store: LabsStore): void {
        store.Model = store.Model.set("IsManualResultsFormPopupOpen", false);
        store.LabActions.RefreshLabs();
    }

    private SwitchTo_LabManualResults(request: LocalEvent, store: LabsStore): void {
        store.LabsInboxModel = store.LabsInboxModel.set("CurrentPage", 1);
        store.LabsInboxModel = store.LabsInboxModel.set("CurrentInbox", LabInboxes.ManualResults);
        store.Model = store.Model.set("CurrentView", LabTabViews.Inbox);
        store.LabActions.GetManualEntries(true);
    }
}

export { LabsTabHandler };
